"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACProgressGroup = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ACProgress_1 = require("./ACProgress");
var ACProgressGroup = function (props) {
    var _a;
    if (!((_a = props === null || props === void 0 ? void 0 : props.options) === null || _a === void 0 ? void 0 : _a.length)) {
        return;
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "flex flex-col gap-2 ".concat(props === null || props === void 0 ? void 0 : props.containerClassName), children: props.options.map(function (op) { return ((0, react_1.createElement)(ACProgress_1.ACProgress, __assign({}, op, { key: op === null || op === void 0 ? void 0 : op.name }))); }) }));
};
exports.ACProgressGroup = ACProgressGroup;
